import { ActivityBuilderModal } from 'approot/activity-builder/activity-builder-modal';
import { PrimaryButton } from 'approot/shared/styles/buttons';
import Text from 'approot/shared/styles/typography/text';
import ImageContentWomanWithQuestionMark from 'approot/shared/images/content/image-content-woman-with-question-mark';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import { Box } from 'approot/shared/design-system/box/box.style';

const StudentConfirmSubmitModal = ({
  onClose,
  onSubmit,
  isSubmitting,
}: {
  onClose: () => void;
  onSubmit: () => void;
  isSubmitting: boolean | undefined;
}) => {
  return (
    <ActivityBuilderModal
      isVisible
      title="Are you ready to submit?"
      headerTitle="Are you ready to submit?"
      size={376}
      onClose={onClose}
      actions={
        <>
          <PrimaryButton
            loading={isSubmitting}
            disabled={isSubmitting}
            onClick={onSubmit}
          >
            Submit
          </PrimaryButton>
          <SecondaryButton onClick={onClose} disabled={isSubmitting}>
            Not yet
          </SecondaryButton>
        </>
      }
    >
      <Box
        $flexDirection="column"
        $alignItems="center"
        $justifyContent="center"
      >
        <Box $marginBottom={24}>
          <ImageContentWomanWithQuestionMark width={120} />
        </Box>
        <Text $marginBottom={8} $align="center">
          You can't change your answers after this!
        </Text>
      </Box>
    </ActivityBuilderModal>
  );
};

export default StudentConfirmSubmitModal;
